import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { ChevronDown16 } from '@carbon/icons-react';

import { SelectOptionMetaType } from '../types';
import SelectItemCheckbox from './SelectItemCheckbox';
import SelectItemRadio from './SelectItemRadio';

interface SelectItemVariantProps {
  type?: SelectOptionMetaType;
  onClick: (
    event: React.ChangeEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
  ) => void;
  parentKey?: string;
  value: string;
  isChecked: boolean;
  dark: boolean;
  isOpen: boolean;
}

const SelectItemVariant: React.FC<SelectItemVariantProps> = ({
  children,
  type,
  onClick,
  parentKey,
  value,
  isChecked,
  dark,
  isOpen,
}) => {
  switch (type) {
    case 'checkbox':
      return (
        <SelectItemCheckbox
          onClick={onClick}
          value={value}
          isChecked={isChecked}
          dark={dark}
        >
          {children}
        </SelectItemCheckbox>
      );

    case 'radio':
      return (
        <SelectItemRadio
          onClick={onClick}
          value={value}
          parentKey={parentKey}
          isChecked={isChecked}
          dark={dark}
        >
          {children}
        </SelectItemRadio>
      );

    case 'parent':
    default:
      return (
        <Flex
          onClick={onClick}
          cursor="pointer"
          _hover={{ bg: dark ? 'gray.900' : 'gray.200' }}
          px={4}
          py={1}
          borderRadius="lg"
          align="center"
        >
          <Box
            as={ChevronDown16}
            transition=".2s transform ease-out"
            transform={`rotate(${isOpen ? 180 : 0}deg)`}
            color={dark ? 'gray.100' : 'gray.700'}
            pointerEvents="none"
            mr={2}
          />
          <Box fontWeight="bold">{children}</Box>
        </Flex>
      );
  }
};

export default SelectItemVariant;
